import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../utils";

async function completeOrder({ action, productOrderId }) {
  const data = await http(`/admin/product-orders/${productOrderId}/complete`, {
    method: "POST",
    data: {
      action,
    },
  });
  return data;
}

export function useCompleteOrder() {
  const queryClient = useQueryClient();

  return useMutation(completeOrder, {
    onSuccess: () => {
      queryClient.refetchQueries(["product-order-parents"]);
    },
  });
}
